export const toggleSelectionInList = (selection: string, list: string[]): string[] => {
  if (list.includes(selection)) {
    return list.filter(item => item !== selection);
  } else {
    return list.concat(selection);
  }
};
